import { Button } from "@heroui/react";
import type { Month } from "./types";

interface MonthRangeButtonProps {
	month: Month;
	menuYear: number;
	selectedDate?: Date;
	minDate?: Date;
	maxDate?: Date;
	monthIndex: number;
	onMonthClick: (month: Month) => void;
}

export const MonthRangeButton = ({
	month,
	menuYear,
	selectedDate,
	minDate,
	maxDate,
	onMonthClick,
}: MonthRangeButtonProps) => {
	// Create a date object for the current button's month and year
	// JavaScript uses 0-indexed months, so month.number is already correct
	const monthDate = new Date(menuYear + month.yearOffset, month.number, 15);

	// Check if this month is the selected one - compare with exact month and year
	const isSelected =
		selectedDate &&
		selectedDate.getMonth() === month.number &&
		selectedDate.getFullYear() === menuYear + month.yearOffset;

	// Check if this month is disabled based on min/max dates (compare by month precision)
	const isDisabled =
		(minDate &&
			(monthDate.getFullYear() < minDate.getFullYear() ||
				(monthDate.getFullYear() === minDate.getFullYear() &&
					monthDate.getMonth() < minDate.getMonth()))) ||
		(maxDate &&
			(monthDate.getFullYear() > maxDate.getFullYear() ||
				(monthDate.getFullYear() === maxDate.getFullYear() &&
					monthDate.getMonth() > maxDate.getMonth())));

	return (
		<td className={"flex-1 p-0.5"}>
			<Button
				variant={isSelected ? "flat" : "light"}
				color={isSelected ? "primary" : "default"}
				className="w-full justify-center font-normal text-sm"
				isDisabled={isDisabled}
				onPress={() => {
					onMonthClick(month);
				}}
			>
				{month.name}
			</Button>
		</td>
	);
};
